<script>
import CommonConstants from '@/common/Constants';
import Utils from '@/common/Utils';
import GenericDataTable from '@/components/generic/GenericDataTable.vue';
import LabelField from '@/components/generic/LabelField.vue';
import config from '@/common/genericPanelConf';
import Service from '@/services/movement-instruction';

export default {
    components: {GenericDataTable, LabelField},
    data(){
        return{
            filters:{
                movementInstructionVoyageNumber: null,
                vesselName: null,
                loadingDateRangeFrom: null,
                loadingDateRangeTo: null,
                topicDescription: null,
                createdAtFrom: null,
                createdAtTo: null,
                start: 0,
                limit: 10
            },
            total: 0,
            visible: false,
            loading: false,
            data: [],
            movementInstructions: [],
            configuration: null,
            details: {},
            detailsVisible: false,
            selectedRow: {id: 0},
            viewModeOptions: ['Compatta', 'Tabella'],
            viewMode: 'Compatta',
            detailsCardVisible: false,
            selectedItem: ""
        }
    },
    created(){
        this.configuration = {...config.getConfiguration('MovementInstruction')};
        this.configuration.toolbarActions = [];
        this.configuration.customActions = [
        {
                title: 'btn.link',
                name: 'link_topic',
                cssClass: 'p-button-rounded p-button-success mr-2',
                icon: 'pi pi-link',
                action: this.hideDialog
            }
        ];
        this.configuration.children.customActions = [];
        this.configuration.sidebarFilters = false;

        if(this.$route.query){
            this.filters.movementInstructionVoyageNumber = this.$route.query.defaultVoyageNumber;
            this.search();
        }
    },
    computed: {
      constants(){
          return CommonConstants;
      },
      utils(){
          return Utils;
      },
      filteredDetails(){
        if(this.details){
            return {
                //topicDescription: this.details.topicDescription,
                vesselName: this.details.vesselName,
                loadingDateRangeFrom: Utils.formatDate(Utils.dateToCurrentTimeZone(this.details.loadingDateRangeFrom)),
                loadingDateRangeTo: Utils.formatDate(Utils.dateToCurrentTimeZone(this.details.loadingDateRangeTo)),
                inspectors: this.details.inspectors,
                demurrageRate: this.details.demurrageRate,
                agents: this.details.agents,
                superIntendent: this.details.superIntendent,
                incoterm: this.details.incoterm,
                trafiguraTradeRef: this.details.trafiguraTradeRef
            }
        }
        return {};
      }
    },
    methods: {
        link(data, caller){
            this.$confirm.require({
                message: this.$t('VesselNomination.linkTopicMessage'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {

                    let body = {
                        idMovementInstructionHeader: data.id,
                        idVesselNominationDocument: this.selectedRow.id
                    };
                    Service.vesselNominationLink(body, response => {
                        this.visible = false;
                        if(response.success){
                            this.search();
                        }else{
                            this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                        }
                    })
                },
                reject: () => {
                    //callback to execute when user rejects the action
                    this.$confirm.close();
                }
            });
            

        },
        onPage(event){
            this.filters.start = event.first;
            this.search();
        },
        search(){
            this.loading = true;
            this.data = []
            this.details = {};
            this.detailsCardVisible = false
            Service.getVesselNomination(this.filters, response => {
                this.loading = false;
                if(response.success){
                    this.data = response.data;
                    this.total = response.totalLongCount;
                }
            })
        },
        openMovementInstructionsDialog(item){
            this.selectedRow = item;
            this.configuration = {...config.getConfiguration('MovementInstruction')};
            this.configuration.toolbarActions = [];
            this.configuration.customActions = [
            {
                    title: 'btn.link',
                    name: 'link_topic',
                    cssClass: 'p-button-rounded p-button-success mr-2',
                    icon: 'pi pi-link',
                    action: this.link
                }
            ];
            this.configuration.children.customActions = [];
            this.configuration.sidebarFilters = false;
            this.configuration.columns.find(c => c.name == 'laycanStartDate').defaultFilterValue = Utils.formatDatePlusDays(Utils.dateToCurrentTimeZone(item.loadingDateRangeFrom), -1)
            this.configuration.columns.find(c => c.name == 'laycanEndDate').defaultFilterValue = Utils.formatDatePlusDays(Utils.dateToCurrentTimeZone(item.loadingDateRangeTo), 1)

            this.visible = true;
        },
        openDetails(item){
            this.details = {};
            this.selectedItem = item.id;
            Service.getVesselNominationById(item.id, response => {
                if(response.success){
                    this.details = response.data;
                    if(this.viewMode == 'Compatta'){
                        this.detailsCardVisible = true;
                    }else{
                        this.detailsVisible = true;
                    }
                }
            })
        },
        hideLabel(field){
            switch(field){
                case 'topicId':
                case 'movementInstructionVoyageNumber':
                case 'movementInstructionVersion':
                case 'parcels':
                    return true;
            }
            return false;
        },
        filterParcel(parcel){
            return { 
                // name: parcel.name,
                consignee: parcel.consignee, 
                notifyAddress: parcel.notifyAddress,
                charterPartyDated: parcel.charterPartyDatedString,
                portOfLoading: parcel.portOfLoading, 
                portOfDischarge: parcel.portOfDischarge, 
                freight: parcel.freight,
                marked: parcel.marked, 
                product: parcel.product, 
                quantity: parcel.quantity, 
                eadConsignee: parcel.eadConsignee,
                eadPlaceOfDelivery: parcel.eadPlaceOfDelivery, 
                // masterForHisOwnUse: parcel.masterForHisOwnUse, 
                // masterForReceivers: parcel.masterForReceivers, 
                //billofLadingUoM: parcel.billofLadingUoM, 
                //documents: parcel.documents 
            }
        },
        openUnlink(data){
            this.$confirm.require({
                message: this.$t('VesselNomination.unlinkMessage'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {
                    Service.vesselNominationUnlink(data.id, response => {
                        this.visible = false;
                        if(response.success){
                            this.search();
                        }else{
                            this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                        }
                    })
                },
                reject: () => {
                    //callback to execute when user rejects the action
                    this.$confirm.close();
                }
            });
        },
        isItemSelected(id){
            return this.selectedItem == id;
        }
    }
}

</script>

<style lang="css" scoped>

.item-selected {
    border: 1px solid var(--primary-color) !important;
}

</style>

<template>
    <Dialog v-model:visible="detailsVisible" modal>
        <div class="grid">
            <div class="col-12 lg:col-2 field" v-for="(value, key) in filteredDetails" :key="key">
                <LabelField :label="$t('VesselNomination.' + key)" :value="value" />
            </div>
        </div>
        <Accordion :activeIndex="0">
            <AccordionTab :header="parcel.name" v-for="parcel in details.parcels" :key="parcel.name">
                <div class="grid">
                   <div class="col-12 lg:col-2 field" v-for="(value, key) in filterParcel(parcel)" :key="key">
                        <LabelField :label="$t('VesselNomination.parcel.' + key)" :value="value" />
                    </div>
                </div>
                <div class="grid">
                    <div class="col-12 lg:col-6">
                        <ResponsiveButton :label="$t('movementInstructions.documents')" icon="pi pi-file" class="p-button-outlined p-button-sm m-1" @click="parcel.showDocuments = !parcel.showDocuments" />
                        <DataTable :reorderableColumns="true" :value="parcel.documents" showGridlines stripedRows dataKey="idRegistryDocument" v-model:expandedRows="expandedRows" class="w-full" v-if="parcel.showDocuments">
                            <template #header>
                                <h4>{{ $t('movementInstructions.documents') }}</h4>
                                <div><LabelField :label="$t('VesselNomination.parcel.masterForHisOwnUse')" :value="parcel.masterForHisOwnUse" class="m-1" /></div>
                                <div><LabelField :label="$t('VesselNomination.parcel.masterForReceivers')" :value="parcel.masterForReceivers" class="m-1" /></div>
                            </template>
                            <Column field="name" :header="$t('documentType.fk')" dataType="string" :sortable="true" />
                            <Column field="originals" :header="$t('movementInstructions.numberOfOriginals')" />
                            <Column field="copies" :header="$t('movementInstructions.numberOfCopies')" />
                            <Column field="counterSignedBySurveyor" :header="$t('movementInstructions.isCounterSignedByInspector')">
                                <template #body="element">
                                {{ element.data.counterSignedBySurveyor ? $t('yes') : $t('no') }}
                                </template>
                            </Column>
                            <Column field="counterSignedOrIssueByOther" :header="$t('movementInstructions.isCounterSignedByThirdparty')">
                                <template #body="element">
                                {{ element.data.counterSignedOrIssueByOther ? $t('yes') : $t('no') }}
                                </template>
                            </Column>
                            <Column field="notes" :header="$t('note')" />
                        </DataTable>
                    </div>
                    <div class="col-12 lg:col-6">
                    <ResponsiveButton :label="$t('movementInstructions.measureUnits')" icon="pi pi-file" class="p-button-outlined p-button-sm m-1" @click="parcel.showUom = !parcel.showUom" />
                        <DataTable :reorderableColumns="true" :value="parcel.billofLadingUoM" showGridlines stripedRows dataKey="idRegistryDocument" class="w-full" v-if="parcel.showUom">
                            <template #header>
                                <h4>{{ $t('movementInstructions.measureUnits') }}</h4>
                            </template>
                            <Column field="uom" :header="$t('description')" />
                        </DataTable>
                    </div>
                </div>
            </AccordionTab>
        </Accordion>    
    </Dialog>
    <Dialog v-model:visible="visible" modal>
        <div class="grid">
            <div class="col-12">
                <GenericDataTable :configuration="configuration" :category="category" :name="selectedRow.id" @on-show-theoretical-lots-dialog="showTheoreticalLotsDialog"/>
            </div>
        </div>
    </Dialog>
    <div class="grid">
        <div class="col-5 grid">
            <div class="col-12 lg:col-4 field">
                <label for="voyageNumber">{{$t('movementInstructions.voyageNumber')}}</label>
                <InputText 
                id="voyageNumber" type="text" 
                v-model="filters.movementInstructionVoyageNumber" 
                :class="{'w-full p-inputtext-sm mt-1 ': true}" />
            </div>
            <div class="col-12 lg:col-4 field">
                <label for="topic">{{$t('Oggetto')}}</label>
                <InputText 
                id="topic" type="text" 
                v-model="filters.topicDescription" 
                :class="{'w-full p-inputtext-sm mt-1 ': true}" />
            </div>
            <div class="col-12 lg:col-4 field">
                <label for="vessel">{{$t('vessel.fk')}}</label>
                <InputText 
                id="vessel" type="text" 
                v-model="filters.vesselName" 
                :class="{'w-full p-inputtext-sm mt-1 ': true}" />
            </div>
        </div>
        <div class="col-5 grid">
            <div class="col-12 lg:col-3 field">
                <label for="laycanFrom">{{$t('movementInstructions.laycanFrom')}}</label>
                <Calendar 
                    :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                    :dateFormat="constants.DATE_FORMAT_POINT"
                    :showTime="false" :hideOnDateTimeSelect="true"
                    id="laycanFrom" 
                    v-model="filters.loadingDateRangeFrom"
                    :showIcon="true" :showButtonBar="true" :yearNavigator="true"
                :class="{'w-full p-inputtext-sm mt-1 ': true}" />
            </div>
            <div class="col-12 lg:col-3 field">
                <label for="laycanTo">{{$t('movementInstructions.laycanTo')}}</label>
                <Calendar 
                :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                :dateFormat="constants.DATE_FORMAT_POINT"
                :showTime="false" :hideOnDateTimeSelect="true"
                id="laycanTo" 
                v-model="filters.loadingDateRangeTo"
                :showIcon="true" :showButtonBar="true" :yearNavigator="true"
                :class="{'w-full p-inputtext-sm mt-1 ': true}" />
            </div>
            
            <div class="col-12 lg:col-3 field">
                <label for="laycanFrom">{{$t('createdOn')}}</label>
                <Calendar 
                    :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                    :dateFormat="constants.DATE_FORMAT_POINT"
                    :showTime="false" :hideOnDateTimeSelect="true"
                    id="laycanFrom" 
                    v-model="filters.createdAtFrom"
                    :showIcon="true" :showButtonBar="true" :yearNavigator="true"
                :class="{'w-full p-inputtext-sm mt-1 ': true}" />
            </div>
            <div class="col-12 lg:col-3 field">
                <label for="laycanTo">{{$t('to')}}</label>
                <Calendar 
                :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                :dateFormat="constants.DATE_FORMAT_POINT"
                :showTime="false" :hideOnDateTimeSelect="true"
                id="laycanTo" 
                v-model="filters.createdAtTo"
                :showIcon="true" :showButtonBar="true" :yearNavigator="true"
                :class="{'w-full p-inputtext-sm mt-1 ': true}" />
            </div>
        </div>
        <div class="col-12 lg:col-2 field  mt-5">
            <ResponsiveButton :label="$t('btn.search')" icon="pi pi-search" class="p-button-outlined p-button-sm m-1" @click="search" />
            <SelectButton v-model="viewMode" :options="viewModeOptions" aria-labelledby="basic" />
        </div>

        <div class="col-12">
            <DataTable :value="data" lazy tableStyle="width: 100%" :loading="loading" paginator :rows="10" :first="0" :totalRecords="total" @page="onPage($event)" v-if="viewMode == 'Tabella'">
                <Column :header="$t('movementInstructions.voyageNumber')">
                    <template #body="element">
                        <Button icon="pi pi-link" class="p-button-sm p-button-rounded p-button-outlined mr-1 mb-1" v-tooltip="$t('btn.link')" @click="openMovementInstructionsDialog(element.data)"    />
                        <Button icon="fa-solid fa-link-slash" class="p-button-sm p-button-rounded p-button-danger p-button-outlined mr-1 mb-1" v-tooltip="$t('btn.unlink')" @click="openUnlink(element.data)"    />
                        <Button icon="pi pi-eye" class="p-button-sm p-button-rounded p-button-outlined p-button-success mr-1 mb-1" v-tooltip="$t('details')" @click="openDetails(element.data)" />
                        {{ element.data.movementInstructionVoyageNumber }}
                    </template>
                </Column>
                <Column field="movementInstructionVersion" :header="$t('version')"></Column>
                <Column field="topicDescription" :header="$t('VesselNomination.topicDescription')"></Column>
                <Column field="vesselName" :header="$t('VesselNomination.vesselName')"></Column>
                <Column field="loadingDateRangeFrom" :header="$t('VesselNomination.loadingDateRangeFrom')">
                    <template #body="element" >
                        <span>
                            {{element.data.loadingDateRangeFrom != null ? utils.formatDate(utils.dateToCurrentTimeZone(element.data.loadingDateRangeFrom)) : null}}
                        </span>
                    </template>
                </Column>
                <Column field="loadingDateRangeTo" :header="$t('VesselNomination.loadingDateRangeTo')">
                    <template #body="element" >
                        <span>
                            {{element.data.loadingDateRangeTo != null ? utils.formatDate(utils.dateToCurrentTimeZone(element.data.loadingDateRangeTo)) : null}}
                        </span>
                    </template>
                </Column>
                <Column field="createdAt" :header="$t('createdOn')">
                    <template #body="element" >
                        <span>
                            {{element.data.createdAt != null ? utils.formatDateTime(utils.dateToCurrentTimeZone(element.data.createdAt)) : null}}
                        </span>
                    </template>
                </Column>
            </DataTable>
        </div>
        <div class="col-4" v-if="viewMode == 'Compatta'">
            <Card>
                <template #title>{{ $t('VesselNomination.threads') }}</template>
                <template #content>
                    <DataView :value="data" lazy paginator :rows="10" :first="0" :totalRecords="total" @page="onPage($event)">
                        <template #list="slotProps">
                            <div class="w-full grid grid-nogutter" :class="{'item-selected': isItemSelected(slotProps.data.id)}">
                                <div class="col-12">
                                    <div class="flex flex-column sm:flex-row sm:align-items-center p-4 gap-3" :class="{ 'border-top-1 surface-border': true }">
                                        <div class="flex flex-column md:flex-row justify-content-between md:align-items-center flex-1 gap-4">
                                            <div class="flex flex-row md:flex-column justify-content-between align-items-start gap-2">
                                                <div>
                                                    <span class="font-medium text-secondary text-sm">
                                                        <LabelField :label="$t('VesselNomination.topicDescription')" :value="slotProps.data.topicDescription" />
                                                    </span>
                                                    <LabelField :label="$t('createdOn')" :value="utils.formatDateTime(utils.dateToCurrentTimeZone(slotProps.data.createdAt))" />
                                                    <LabelField :label="$t('VesselNomination.vesselName')" :value="slotProps.data.vesselName" />
                                                    <LabelField :label="$t('VesselNomination.loadingDateRangeFrom')" :value="utils.formatDate(utils.dateToCurrentTimeZone(slotProps.data.loadingDateRangeFrom))" />
                                                    <LabelField :label="$t('VesselNomination.loadingDateRangeTo')" :value="utils.formatDate(utils.dateToCurrentTimeZone(slotProps.data.loadingDateRangeTo))" />
                                                </div>
                                            </div>
                                            <div class="flex flex-column md:align-items-end gap-5">
                                                <span class="text-xl font-semibold text-900">
                                                    {{ slotProps.data.movementInstructionVoyageNumber }}
                                                    <span v-if="slotProps.data.movementInstructionVersion">
                                                        - {{ $t('version') }} {{ slotProps.data.movementInstructionVersion }}
                                                    </span>
                                                </span>
                                                <div class="flex flex-row-reverse md:flex-row gap-2">
                                                    <Button icon="pi pi-link" class="p-button-sm p-button-rounded p-button-outlined mr-1 mb-1" v-tooltip="$t('btn.link')" @click="openMovementInstructionsDialog(slotProps.data)" />
                                                    <Button icon="fa-solid fa-link-slash" class="p-button-sm p-button-rounded p-button-danger p-button-outlined mr-1 mb-1" v-tooltip="$t('btn.unlink')" @click="openUnlink(slotProps.data)" v-if="slotProps.data.movementInstructionVoyageNumber" />
                                                    <Button icon="pi pi-eye" class="p-button-sm p-button-rounded p-button-outlined p-button-success mr-1 mb-1" v-tooltip="$t('details')" @click="openDetails(slotProps.data)" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </DataView>   
                </template>
            </Card>
        </div>
        <div class="col-8" v-if="detailsCardVisible && viewMode == 'Compatta'">
            <Card>
                <template #title>{{ details.topicDescription }}</template>
                <template #content>
                    <div class="grid">
                        <div class="col-12 lg:col-2 field" v-for="(value, key) in filteredDetails" :key="key">
                            <LabelField :label="$t('VesselNomination.' + key)" :value="value" />
                        </div>
                    </div>
                    <Accordion :activeIndex="0">
                        <AccordionTab :header="parcel.name" v-for="parcel in details.parcels" :key="parcel.name">
                            <div class="grid">
                            <div class="col-12 lg:col-2 field" v-for="(value, key) in filterParcel(parcel)" :key="key">
                                    <LabelField :label="$t('VesselNomination.parcel.' + key)" :value="value" />
                                </div>
                            </div>
                            <div class="grid">
                                <div class="col-12 lg:col-6">
                                    <ResponsiveButton :label="$t('movementInstructions.documents')" icon="pi pi-file" class="p-button-outlined p-button-sm m-1" @click="parcel.showDocuments = !parcel.showDocuments" />
                                    <DataTable :reorderableColumns="true" :value="parcel.documents" showGridlines stripedRows dataKey="idRegistryDocument" v-model:expandedRows="expandedRows" class="w-full" v-if="parcel.showDocuments">
                                        <template #header>
                                            <h4>{{ $t('movementInstructions.documents') }}</h4>
                                            <div><LabelField :label="$t('VesselNomination.parcel.masterForHisOwnUse')" :value="parcel.masterForHisOwnUse" class="m-1" /></div>
                                            <div><LabelField :label="$t('VesselNomination.parcel.masterForReceivers')" :value="parcel.masterForReceivers" class="m-1" /></div>
                                        </template>
                                        <Column field="name" :header="$t('documentType.fk')" dataType="string" :sortable="true" />
                                        <Column field="originals" :header="$t('movementInstructions.numberOfOriginals')" />
                                        <Column field="copies" :header="$t('movementInstructions.numberOfCopies')" />
                                        <Column field="counterSignedBySurveyor" :header="$t('movementInstructions.isCounterSignedByInspector')">
                                            <template #body="element">
                                            {{ element.data.counterSignedBySurveyor ? $t('yes') : $t('no') }}
                                            </template>
                                        </Column>
                                        <Column field="counterSignedOrIssueByOther" :header="$t('movementInstructions.isCounterSignedByThirdparty')">
                                            <template #body="element">
                                            {{ element.data.counterSignedOrIssueByOther ? $t('yes') : $t('no') }}
                                            </template>
                                        </Column>
                                        <Column field="notes" :header="$t('note')" />
                                    </DataTable>
                                </div>
                                <div class="col-12 lg:col-6">
                                <ResponsiveButton :label="$t('movementInstructions.measureUnits')" icon="pi pi-file" class="p-button-outlined p-button-sm m-1" @click="parcel.showUom = !parcel.showUom" />
                                    <DataTable :reorderableColumns="true" :value="parcel.billofLadingUoM" showGridlines stripedRows dataKey="idRegistryDocument" class="w-full" v-if="parcel.showUom">
                                        <template #header>
                                            <h4>{{ $t('movementInstructions.measureUnits') }}</h4>
                                        </template>
                                        <Column field="uom" :header="$t('description')" />
                                    </DataTable>
                                </div>
                            </div>
                        </AccordionTab>
                    </Accordion>    
                </template>
            </Card>
        </div>

    </div>
</template>